import { RichTextInput } from 'ra-input-rich-text';
import { Edit, SimpleForm } from 'react-admin';

export const ClientNoteEdit: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const redirect = (basePath: any, id: any, data: any) => {
    return `Client/${data.client.id}/show/notes`;
  };

  return (
    <Edit mutationMode="pessimistic" redirect={redirect}>
      <SimpleForm>
        <RichTextInput
          label="Poznámka"
          source="text"
          sx={{ '& .tiptap': { minHeight: '20em' }, maxWidth: '40em', width: '100%' }}
        />
      </SimpleForm>
    </Edit>
  );
};
